import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import { Table, Button } from "react-bootstrap";
import HighlightedDetailTab from "../../commoncomponents/highlightedDetailTab";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import LocationTable from "./pointTable";
import MultiDropDown from "../../commoncomponents/multiDropDown";
import GroupWarning from "../../commoncomponents/groupWarning";

class PointOfInterest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: "Select start date",
      calendarSelect: false,
      calendarSelect2: false,
      dataPlaceholder2: "Select end date",
      calendarStartDate: new Date(),
      calendarEndDate: new Date(),
      assetShow: false,
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      ReportDate: new Date(),
      globalDate: [],
      poiData: [],
      selectedPoiName: "Select POI",
      // POIId: "",
      selectGroupId: "",
      endDate: new Date(),
      calendarShow: false,
      calendarShow2: false,
      checked: true,
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      POIId: [],
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      isLoading:false,
      assetLoading:false
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  async componentDidMount() {
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if(GroupList.status===200)
      {
        this.setState({isLoading:false, groupDetails: GroupList.data  });
      }
      else {
        this.setState({isLoading:true });
      }
      // this.setState({ groupDetails: GroupList.data });
      console.log("group details", GroupList.data);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false, calendarShow2: false });
    }
  }

  getAssets = async () => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if(AssetList.status===200)
      {
        this.setState({assetLoading:false, AssetList: AssetList.data.paggedlist, assetLoader: false,  });
      }
      else {
        this.setState({assetLoading:true });
      }
      // this.setState({
      //   AssetList: AssetList.data.paggedlist,
      //   assetLoader: false,
      // });
      console.log("group details", AssetList.data.paggedlist);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (customer, name, id, customerId) => {
    this.setState({ assetLoader: true });
    this.groupId = id;
    this.customerId = customerId;
    if(id == 0){


    }else{
      this.setState({
        groupId: id,
        groupCustomerName: customer,
        groupGeneralName: name,
        assetCustomerName: "",
        assetGeneralName: "",
        assetTabHeading: true,
        groupTabHighlight: false,
        assetTabHighlight: true,
        groupTabHeading: false,
      });

    }
    console.log(customer, name);
    this.getAssets();
  };
  handleAssetSelection = (asset, name, id) => {
    this.setState({
      assetId: id,
      assetCustomerName: asset,
      assetGeneralName: name,
      // groupTabHighlight:false,
      assetTabHighlight: false,
      assetTabHeading: false,
    });
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    console.log("daateeeee", date);
    console.log("clicked date mvtl", moment(date).format("YYYY-MM-DD"));
    this.setState({
      calendarSelect: true,
      calendarStartDate: date,
      globalDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  calendarFunction2 = () => {
    if (this.state.globalDate != "") {
      this.setState({
        calendarShow2: !this.state.calendarShow2,
      });
    } else {
      alert("select start date");
    }
  };
  onChangeDate2 = (date) => {
    console.log("end date", date);
    this.setState({
      calendarSelect2: true,
      calendarEndDate: date,
      endDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder2: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow2: false,
    });
  };
  handleCheckup = () => {
    console.log(this.state.checked);
    this.setState({
      checked: !this.state.checked,
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  handleGroupSelect = (data) => {
    console.log("value", data);

    let POIArr = []
    if (data.some(poiAll => poiAll.id == 0)) {
      this.state.poiData.forEach((item, index) => {
        if(item.id != 0)
        POIArr.push(item.id)
      });
    } else {
      data.forEach((single, index) => {
        POIArr.push(single.id);
      });
    }

    this.setState({
      POIId: POIArr,
    });
    console.log("POIId", POIArr);
  };

  handlePoiDropDownNew = async () => {
    try {
      let poiList = await axios.get(
        `${apiHost}/api/POI/GetAllPOIs?customerId=${this.customerId}`,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      // debugger;
      poiList.data.unshift({id: 0, name: "All"})

      this.setState({
        poiData: poiList.data,
      });
      console.log("group details", poiList.data);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  handlePoiDropDown = async () => {
    try {
      let poiList = await axios.get(
        `${apiHost}/api/POI/GetAllByAssetId/${this.state.assetId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        poiData: poiList.data,
      });
      console.log("group details", poiList.data);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  handleCreateReport = async () => {
    this.setState({
      reportDetails:[],
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/POIReport`,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: this.state.checked,
          EndDate: this.state.endDate,
          POIIds: this.state.POIId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      console.log("group details----", ReportDetails);
      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  render() {
    const GroupTable = (
      <div
        className={
          this.state.groupTabHighlight ? "tableHeight" : "tableSmoothHeight"
        }
      >
        <Table striped responsive hover>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Name</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {this.state.groupDetails.map((item, index) => {
              return (
                <tr
                  className="trRow"
                  title="click to select"
                  id="1"
                  onClick={(e) =>
                    this.handleGroupSelection(
                      item.customername,
                      item.groupName,
                      item.groupId,
                      item.customerId
                    )
                  }
                >
                  <td>{item.customername}</td>
                  <td>{item.groupName}</td>
                  <td>{item.description}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );

    const AssetTable = (
      <div
        className={
          this.state.assetTabHighlight ? "tableHeight" : "tableSmoothHeight"
        }
      >
        {!this.state.assetLoading && this.state.AssetList.length>0 ? (
          <Table striped hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.AssetList.map((item, index) => {
                return (
                  <tr
                    className="trRow"
                    title="click to select"
                    id="1"
                    onClick={(e) =>
                      this.handleAssetSelection(
                        item.name,
                        item.customerName,
                        item.assetId
                      )
                    }
                  >
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.statusId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : this.state.assetLoading && (
          <AssetInforWarning
            warningText={true}
            warningTextMsg=" No assets found"
          />
        )}
      </div>
    );

    const data = (
      <div
        className={
          this.state.assetShow
            ? "dropDownContainer smoothHeight"
            : "dropDownContainer"
        }
      >
        {!this.state.isLoading && this.state.groupDetails.length > 0 ? (
          <div className="dropDownContentMainContainer">
            <div className="dropDownHeading">
              {this.state.groupTabHeading ? (
                <h1>1. Select Group</h1>
              ) : (
                <HighlightedDetailTab
                  leftIcon="fa-th"
                  functionCall={this.toggleGroupTable}
                  click={this.state.groupTabHighlight}
                  customerName={this.state.groupCustomerName}
                  generalName={this.state.groupGeneralName}
                  count="114"
                />
              )}
            </div>
            <div className="dropDownContent">
              {GroupTable}
              {/* {this.state.groupTabHighlight?
                  :""
                } */}
            </div>
            <br />
            {this.state.groupId != "" ? (
              <div>
                <div className="dropDownHeading">
                  {this.state.assetTabHeading ? (
                    <h1>2. Select Asset</h1>
                  ) : (
                    <HighlightedDetailTab
                      leftIcon="fa-truck"
                      click={this.state.assetTabHighlight}
                      functionCall={this.toggleAssetTable}
                      customerName={this.state.assetCustomerName}
                      generalName={this.state.assetGeneralName}
                      count="34"
                    />
                  )}
                </div>
                {!this.state.assetLoader ? (
                  <div className="dropDownContent">{AssetTable}</div>
                ) : (
                  <center>
                    <br />
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.assetLoader}
                    />
                    <br />
                  </center>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="dropDownFooter">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  this.setState({ assetShow: false });
                }}
              >
                Cancel
              </Button>
              &nbsp;
              {this.state.assetCustomerName != "" &&
              this.state.groupGeneralName != "" ? (
                <Button
                  onClick={() => {
                    this.setState({
                      assetShow: false,
                      assetPlaceholder: this.state.assetCustomerName,
                    });
                    this.handlePoiDropDownNew();
                  }}
                  variant="success"
                >
                  OK
                </Button>
              ) : (
                <Button variant="success" disabled>
                  OK
                </Button>
              )}
            </div>
          </div>
        ) : this.state.isLoading && (
          <center>
            <br />
            <GroupWarning
                    warningText={true}
                    warningTextHead="No Groups Found"
                    warningTextBody= " You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                  />
            <br />
          </center>
        )}
      </div>
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={new Date()}
            //  minDate={moment(this.state.globalDate[0]).subtract(3, 'months').toDate()}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    const calendarReport2 = this.state.calendarShow2 ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            minDate={this.state.globalDate}
            maxDate={
              moment(this.state.globalDate).add(3, "months").toDate() >
              new Date()
                ? new Date()
                : moment(this.state.globalDate).add(3, "months").toDate()
            }
            onChange={this.onChangeDate2}
            value={this.state.calendarEndDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    return (
      <Layout>
        <Helmet>
          <title>Point Of Interest</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease`
                : `contentWrapper contentWrapperSmooth`
            }
          >
            <div className="headingContainer">
              <h2 className="mainHeading">
                Point Of Interest <span>v2.0.4</span>
              </h2>
              <i
                className={
                  this.props.headerHide
                    ? `fa fa-window-restore`
                    : `fa fa-window-maximize`
                }
                onClick={this.handleWindow}
              />
            </div>
            <hr />
            <div className="inputFormGroup">
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.truckFunction}
                  dropDown={data}
                  placeholder={this.state.assetPlaceholder}
                  icon="fa-truck"
                />
              </div>
              <div className="inputElement">
                <MultiDropDown
                  caption={this.state.selectedPoiName}
                  icon="fa-truck"
                  values={this.state.poiData}
                  onParentCall={this.handleGroupSelect}
                  fromPOI="true"
                  assetData={this.state.poiData}
                  selectGroupId={this.state.poiData}
                />
              </div>
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.calendarFunction}
                  dropDown={calendarReport}
                  placeholder={this.state.dataPlaceholder}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
                <ReportButtonGroup
                  function={this.calendarFunction2}
                  dropDown={calendarReport2}
                  placeholder={this.state.dataPlaceholder2}
                  icon="fa-calendar"
                />
              </div>
              <div className="inputElement">
                {/* <p>
                  <input
                    type="checkbox"
                    onChange={this.handleCheckup}
                    checked={this.state.checked}
                  ></input>{" "}
                  Use Filtering{" "}
                </p> */}
                {this.state.assetCustomerName != "" &&
                this.state.POIId != "" &&
                this.state.calendarSelect &&
                this.state.calendarSelect2 ? (
                  <Button
                    variant="outline-secondary"
                    onClick={this.handleCreateReport}
                    size="sm"
                  >
                    {" "}
                    Create Report{" "}
                  </Button>
                ) : (
                  <Button
                    variant="outline-secondary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled
                  >
                    {" "}
                    Create Report{" "}
                  </Button>
                )}
              </div>
            </div>
            <TimeZoneConvert />
            {/* this.state.assetSelectionBoolean */}
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br />{" "}
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.reportLoader}
                    />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <div className="loaderLine">
                    <h1>Something Went Wrong...!</h1>
                  </div>
                ) : (
                  <React.Fragment>
                    <LocationTable pointData={this.state.reportDetails}
                      assetCustomerName = { this.state.assetCustomerName}
                      timeZone = {this.state.calendarStartDate}
                    />
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(PointOfInterest);
